import emailjs from 'emailjs-com';

export const sendEmail = (e, setNotification) => {
    emailjs.sendForm('service_zkv0pzh', 'template_53k1t8i', e.target, 'user_44SfA9a2DcUOyBra8BV5h')
        .then((result) => {
            if (result.text === 'OK') {
                setNotification({ type: 'success', msg: 'Message sent successfully' });
                setTimeout(() => setNotification({}), 2000)
            }
            e.target.reset();
        }, (error) => {
            setNotification({ type: 'danger', msg: 'Something went wrong! Please try again' });
            setTimeout(() => setNotification({}), 2000);
            e.target.reset();
        });
}